import { useState } from "react";
import { Upload, message } from "antd";
import DragIcon from "../../../assets/icons/ic_drag.svg";

import "./stylesCustomDragAndDrop.css";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { formatString } from "../../../utils/constants/stringUtils";

const { Dragger } = Upload;

const CustomDragAndDrop = ({
  onFileUpload,
  onRemove,
  title = AppStrings.DRAG_N_DROP_TO_UPLOAD_ICON,
  description = AppStrings.DRAG_N_DROP_TO_UPLOAD_ICON_DESCRIPTION,
  maxSizeMB,
  allowedMimeTypes = ["image/png", "image/svg+xml"],
  allowedExtensions = [".png", ".svg"],
  allowedTypesMessage = "Only PNG or SVG files are allowed.",
  fileList: controlledFileList,
  onFileListChange,
}) => {
  const [internalFileList, setInternalFileList] = useState([]);
  const isFileListControlled = controlledFileList !== undefined;
  const fileList = isFileListControlled ? controlledFileList : internalFileList;

  const updateFileList = (nextFileList) => {
    if (!isFileListControlled) {
      setInternalFileList(nextFileList);
    }
    onFileListChange?.(nextFileList);
  };

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    fileList,
    beforeUpload: (file) => {
      const mimeType = file?.type?.toLowerCase();
      const fileName = file?.name?.toLowerCase() || "";
      const fileSizeMB = file?.size ? file.size / 1024 / 1024 : 0;
      const isAllowedType =
        allowedMimeTypes.includes(mimeType) ||
        allowedExtensions.some((ext) => fileName.endsWith(ext));

      if (!isAllowedType) {
        message.error(allowedTypesMessage);
        return Upload.LIST_IGNORE;
      }

      if (maxSizeMB && fileSizeMB > maxSizeMB) {
        message.error(
          formatString(AppStrings.PAM_FILE_SIZE_LIMIT_EXCEEDED, {
            maxSizeMb: String(maxSizeMB),
          })
        );
        return Upload.LIST_IGNORE;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        onFileUpload(reader.result, file);
        updateFileList([file]);
      };
      reader.onerror = () => {
        message.error(AppStrings.FAILED_TO_READ_IMAGE);
      };
      return false; 
    },
    onRemove() {
      updateFileList([]);
      onRemove();
    },
  };

  return (
    <div className="drag-and-drop-container">
      <Dragger
        {...props}
        accept={[...allowedMimeTypes, ...allowedExtensions].join(",")}
      >
        <img
          src={DragIcon}
          alt="drag and drop icon"
          className="ant-upload-drag-icon"
        />
        <p className="ant-upload-text">{title}</p>
        <p className="ant-upload-hint">{description}</p>
        <button type="button" className="browse-file">
          {AppStrings.BROWSE_FILE}
        </button>
      </Dragger>
    </div>
  );
};

export default CustomDragAndDrop;
